import { ActionIcon, Tooltip } from '@mantine/core';
import { Icon, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { useGetHistoryDisabledState } from 'app/modules/wallforming/components/placement-history/hooks/useGetHistoryDisabledState';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import 'app/modules/wallforming/custom-styles/customButtonStyle.css';

const isLargeScreen = window.screen.width >= 1920;

export const HistoryTools = () => {
    const { t } = useTranslation();
    const disabled = useGetHistoryDisabledState();

    const history = usePlacementStore(
        useShallow((state) => ({
            canUndo: state.canUndo,
            canRedo: state.canRedo,
            undoLabel: state.undoLabel,
            redoLabel: state.redoLabel,
            repeatCount: state.repeatHistory.length,
            repeatLabel: state.repeatHistory[state.repeatHistory.length - 1]?.label,
            repeatLast: state.repeatLast,
            undo: state.undo,
            redo: state.redo
        }))
    );

    return (
        <>
            <Tooltip
                label={`${t('repeatLast')}${history.repeatLabel ? `: ${t(history.repeatLabel)}` : ''}`}
                position="right"
                variant={variants.tooltip.right}
            >
                <ActionIcon
                    aria-label={t('repeatLast')}
                    className={`${disabled ? '' : 'bg-background-gray-ultra-light hover:bg-background-gray!'} ${
                        isLargeScreen ? 'action-icon-large' : 'action-icon-medium'
                    }`}
                    disabled={disabled || history.repeatCount === 0}
                    onClick={() => history.repeatLast()}
                >
                    <Icon aria-hidden="true" icon="repeat" />
                </ActionIcon>
            </Tooltip>
            {(['undo', 'redo'] as const).map((direction) => {
                const label = direction === 'undo' ? history.undoLabel : history.redoLabel;
                const available = direction === 'undo' ? history.canUndo : history.canRedo;
                return (
                    <Tooltip
                        key={direction}
                        label={`${t(direction)}${label ? `: ${t(label)}` : ''}`}
                        position="right"
                        variant={variants.tooltip.right}
                    >
                        <ActionIcon
                            aria-label={t(direction)}
                            className={`${disabled ? '' : 'bg-background-gray-ultra-light hover:bg-background-gray!'} ${
                                isLargeScreen ? 'action-icon-large' : 'action-icon-medium'
                            }`}
                            disabled={disabled || !available}
                            onClick={() => history[direction]()}
                        >
                            {direction}
                        </ActionIcon>
                    </Tooltip>
                );
            })}
        </>
    );
};
